/**
 * Shared ERIS domain constants used across backoffice components.
 */

/** Display labels for the contract/CUPS tariff codes. */
export const TARIFF_LABELS: Record<string, string> = {
	T_20TD: '2.0TD',
	T_30TD: '3.0TD',
	T_61TD: '6.1TD',
	GAS_RL1: 'GAS RL1',
	GAS_RL2: 'GAS RL2',
	GAS_RL3: 'GAS RL3',
	GAS_RL4: 'GAS RL4',
};

/** Palette accepted by <app-tag>. */
export type TagColor = 'yellow' | 'blue' | 'green' | 'red' | 'gray';

/** Looks up a tag color in a domain map, falling back to gray. */
export function tagColor(map: Record<string, TagColor>, key: string | null | undefined): TagColor {
	return map[key ?? ''] ?? 'gray';
}
